import { TimeInput, TimeInputProps } from '@heroui/react';
import { forwardRef } from '@heroui/system';

const CustomTimeInput = forwardRef<'div', TimeInputProps>((props, ref) => {
  const { label, value, startContent, onChange, ...restProps } = props;

  return (
    <TimeInput
      ref={ref}
      label={label}
      value={value}
      startContent={startContent}
      onChange={onChange}
      classNames={{
        base: 'tmdx-input tmdx-timeinput group',
        inputWrapper: [
          'bg-base-60',
          'group-data[focus=true]:bg-base-40',
          'group-data-[invalid=true]:bg-red-80',
          'tmdx-input__wrapper',
          'tmdx-timeinput__wrapper',
          'rounded-lg',
          'transition-none!',
          !!startContent && 'hasStartContent',
          !!value && 'hasValue',
          !label && 'min-h-8 h-8',
          !!label && 'hasLabel',
          'shadow-none',
        ],
        input: [
          'text-base-5',
          'placeholder:text-base-30',
          'text-m-r!',
          'group-data-[invalid=true]:text-base-5!',
          'tmdx-input__item',
        ],
        label: [
          'text-base-20',
          'text-s-r!',
          'tmdx-input__label',
          'group-focus-within:text-base-10',
          'group-data-[invalid=true]:text-danger!',
        ],
        description: ['text-base-20', 'text-s-r', 'group-data-[invalid=true]:text-danger', 'form-item__description'],
        innerWrapper: ['bg-transparent'],
        segment: 'slashed-zero',
      }}
      {...restProps}
    />
  );
});

CustomTimeInput.displayName = 'CustomTimeInput';

export default CustomTimeInput;
